import { useHistory } from "react-router-dom"
import logo from '../Image/marioLogo5.png'
export default function Navigation () {
  const history = useHistory()
  function goHomePage () {
    history.push("/");
  }
  function goMyFavoritePage () {
    history.push("/myFavorite");
  }
  return (
    <nav className="navbar justify-content-between" style={{backgroundColor: "red"}}>
      <div style={{display: 'flex'}}>
        <img src={logo} style={{margin: 1}} width="55" height="55" className="d-inline-block align-top" alt=""/>
      </div>
      <div style={{display: 'flex'}}>
        <button className="btn btn-outline-light" style={{margin: 3}} onClick={ goHomePage }>Home</button>
        <button className="btn btn-outline-light" style={{margin: 3}} onClick={ goMyFavoritePage }>My Favorite</button>
      </div>
    </nav>
  )
}

